import React from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button
} from "reactstrap";
import "../../styles/estilos.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Checkbox } from "react-inputs-validation";

class ValoresFacturacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      height: window.innerHeight,
      terminosHabilitado :false,
      claseDivFix: "flex-row div-flotante",
    }
    this.handleScroll = this.handleScroll.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.onActualizar = this.onActualizar.bind(this);

  }

  onDismiss() {
    this.setState({ visibleAlert: false });
  }

  toggleValidating = (validate) => {
    this.setState({ validate });
  }


  onActualizar(e) {
        this.props.validarFormulario();
  }
  
  /* Eventos Scroll */
  handleScroll() {
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
        if (windowBottom >= (docHeight -100)) {
          this.setState({
            claseDivFix: 'flex-row div-flotante fix-botton-totales-resumen'
          });
        } else {
          this.setState({
            claseDivFix: 'flex-row div-flotante'
          });
        }
 
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    const {claseDivFix,terminosHabilitado} = this.state;
    const {valoresTotales} = this.props;
    let valorTotal = {
      primaNeta: "0.00",
      primaTotal: "0.00",
      impuestos : [{nombre:"Superintendencia 3.5%", valor:"0.0"},
                    {nombre:"Seguro Campesino 0.5%", valor:"0.0"},
                    {nombre:"Derechos de emisión", valor:"0.0"},
                    {nombre:"IVA 15%", valor:"0.0"}],
      totalImpuestos: "0.00"
    }

    if(valoresTotales) {                 
      valorTotal = {
        primaNeta: valoresTotales.primaNeta,
        impuestos: valoresTotales.impuestos,
        primaTotal: valoresTotales.primaTotal,
        totalImpuestos: valoresTotales.totalImpuestos
      }
    }
    return (

      <Card className={claseDivFix}>
        <CardBody>
          <div>
          <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <h5>Prima Neta</h5>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <h5>${valorTotal.primaNeta}</h5>
            </Col>
          </Row>
          <Row>
            <div id="container-imp">
              <div className="accordion-imp">
                <input type="checkbox" id="tm" />
                <label htmlFor="tm" className="accordionitem">
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5 title={"Presiona click para ver/ocultar el detalle impuestos"} >
                        Impuestos{" "}
                        <i
                          className="fa fa-info-circle"
                          aria-hidden="true"
                        />
                      </h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${valorTotal.totalImpuestos}</h5>
                    </Col>
                  </Row>
                </label>
                <div className="hiddentext ocultar">
                {valorTotal.impuestos !== undefined && 
                      valorTotal.impuestos.map((impuesto, i) => {
                        return (
                          <Row key={'item:' + i} >
                            <Col lg={6} md={6} sm={6} xs={6}>
                              <h5>{impuesto.nombre}</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={6}>
                              <h5>${impuesto.valor}</h5>
                            </Col>
                          </Row>
                        );      
                      })
                    }  
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
              <h5 style={{ fontWeight: "bold" }}>Prima Total</h5>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
              <h5 style={{ fontWeight: "bold" }}>${valorTotal.primaTotal}</h5>
            </Col>
          </Row>
          <hr />
          <Row>
              <Col lg={12} md={12} sm={12} xs={21}>
                <table style={{ margin: "auto" }}>
                  <tbody>
                  <tr>
                    <td>
                      <Checkbox
                        id={"terminosycondiciones"} // Optional.[String].Default: "".  Input ID.
                        name={"terminosycondiciones"} // Optional.[String].Default: "". Input name
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        checked={terminosHabilitado} // Required.[Bool].Default: false.
                        onChange={(terminosHabilitado, e) => {
                          this.setState({
                            terminosHabilitado
                          });
                          //console.log("terminosHabilitado", terminosHabilitado);
                        }} // Required.[Func].Default: () => {}. Will return the value.
                        validationOption={{
                          name: "terminosycondiciones", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </td>
                    <td>
                      <a className="btn-color-main"  title="Ver Términos y Condiciones" href={this.props.dataUsuario.disclaimerUrl} target="_blank"><h6 style={{ marginTop: "0.4em" }}> Aceptar Términos y Condiciones </h6></a>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </Col>
              <hr />
            </Row>
          <Row className="mb-3">
            <Col lg={12} md={12} sm={12} xs={12}>
                <Button
                    className={"btn btn-primary"}
                    onClick={this.onActualizar}
                    style={{ display: "block", margin: "auto" }}
                    disabled={!terminosHabilitado}
                >
                <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                {"CONTINUAR"}
                </Button>
            </Col>
          </Row>
          </div>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  dataUsuario: state.datosUsuarios.dataUsuario,

});

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ValoresFacturacion)
);
